<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P6DboY/tc-custom/9781638490852.jpg?1706994110576" alt="This image is the cover for the book Engineward"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Engineward
      </h1>
      <p class="bookDescription body article font2">
        <p>A post-apocalyptic, zodiac-inspired science fiction mystery with a take-no-prisoners female lead who blazes a trail to correct the past.                                                              EARTH IS AN ANCIENT MYTH                                                                    Earth is long forgotten. Now, the word of the god-like Celestials is absolute, and they rule with brutal efficiency. When Joss, an Engineward, discovers and reactivates the head of an ancient ghoulem, she finds all is not as intended. Her destiny—and that of her world—lies somewhere far beyond the borders of her shantytown.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Mann, Joe Eisma
      </h2>
      
      <p class="authorDescription body article">George Mann is the Sunday Times bestselling novelist, scriptwriter, and creator of the supernatural crime series, Wychwood. Mann is author of the Newbury and Hobbes and The Ghost series of novels, as well as numerous short stories, novellas and audiobooks. He has written fiction and audio scripts for the BBC’s Doctor Who and Sherlock Holmes. He is also a respected anthologist and has edited The Solaris Book of New Science Fiction and The Solaris Book of New Fantasy. He lives near Grantham, UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Vault Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65468e22